import { FC } from 'react';
import { useRouter } from 'next/router';
import { getNextApiUrl } from '@/utils/next-api';
import { StickyFooter } from '@/layouts/StickyFooter';
import { useLogin } from '@/modules/register/hooks';
import Button from '@/components/Button';
import { Link } from '@/components/Link';
import { MainSplashScreen } from '@/components/Splash';
import Story from '@/components/Story';
import { useImagesPreloader } from '@/hooks/ImagePreloader';
import { useModifyBodyScrollOverflow } from '@/hooks/scroll';
import { useRegisterLimitations } from '@/modules/register/hooks/useRegisterLimitations';

const INTRO_IMAGES_URLS = [
  'https://s3.ir-thr-at1.arvanstorage.com/mofidapp/IntroPro/introA.png',
  'https://s3.ir-thr-at1.arvanstorage.com/mofidapp/IntroPro/introB.png',
  'https://s3.ir-thr-at1.arvanstorage.com/mofidapp/IntroPro/introC.png',
  'https://s3.ir-thr-at1.arvanstorage.com/mofidapp/IntroPro/introD.png',
];

const AppIntro: FC = () => {
  const { registerLink } = useRegisterLimitations();
  const { handleUtmLogin } = useLogin();

  const router = useRouter();

  const handleRegisterClick = () => {
    router.push(registerLink);
  };

  useModifyBodyScrollOverflow(true, 'hidden');

  const { isImagesPreloaded } = useImagesPreloader(INTRO_IMAGES_URLS);

  if (!isImagesPreloaded) return <MainSplashScreen />;

  return (
    <div className="relative h-screen w-full">
      <Story
        defaultInterval={10000}
        id="story-container"
        loop={true}
        slides={INTRO_IMAGES_URLS.map((image) => ({
          id: image,
          url: image,
        }))}
        storyContainerStyles={{
          background:
            'linear-gradient(180deg, #DBDFE6 0%, rgba(248, 249, 250, 0.49) 100%)',
        }}
      />
      <StickyFooter className="z-[1000] rounded-t-2xl border-t border-gray-40 !shadow-sm">
        <div className="flex flex-col gap-4">
          <div className="grid grid-cols-2 gap-2">
            <Button
              analytics={['AUTH_LOGIN']}
              id="auth_submit_login"
              isFullWidth
              // login in auth page should always point to account login url
              onClick={handleUtmLogin}
            >
              ورود
            </Button>
            <Button
              analytics={['AUTH_CREATE_ACCOUNT']}
              id="auth_submit_createAccount"
              variant="outline"
              isFullWidth
              onClick={handleRegisterClick}
            >
              ایجاد حساب
            </Button>
          </div>
          <Link
            analytics={['AUTH_PRIVACY_POLICY']}
            className="text-center text-xs font-medium text-gray-70"
            href={getNextApiUrl('privacy')}
            id="auth_click_privacyPolicy"
            target="_blank"
          >
            قوانین حریم شخصی
          </Link>
        </div>
      </StickyFooter>
    </div>
  );
};

export default AppIntro;
